<div data-pw="inbox-page" class="jhmi-inbox jhm-page" [class.mobile]="screenSize==='MOBILE'">
  <div class="jhm-top-toolbar">
    <div class="left">
      <div class="title-item">
        <div class="fa-solid fa-bars nav-open test-class" (click)="openNav()"></div>
        <div class="title">
          Inbox
        </div>
      </div>
    </div>
    <div class="right">
      <button data-pw="inbox-new-message-btn" class="action jhm-button primary" (click)="onNewMessageClick()"><i class="fa-solid fa-plus"></i>New Message</button>
    </div>
  </div>
  <jhm-table
    [refreshTableData]="refreshTableData"
    [repository]="messageRepository"
    [zeroState]="'inbox'"
    [portalName]="userType"
    (cellClicked)="messageClicked($event)">
  </jhm-table>
</div>
@if (showConfirmDeleteModal) {
  <div class="jhm-modal-background">
    <div id="delete-draft-modal" class="jhm-modal delete-draft-modal">
      <header>
        <div class="title">
          <h2>Delete Message?</h2>
          <button class="jhm-button" (click)="showConfirmDeleteModal = false">
            <img src="./assets/images/black-x.svg">
          </button>
        </div>
      </header>
      <div>
        Are you sure you'd like to delete this message?
      </div>
      <footer class="filled">
        <button class="jhm-button" (click)="showConfirmDeleteModal = false">Cancel</button>
        <button class="jhm-button primary" (click)="deleteMessage()">Delete</button>
      </footer>
    </div>
  </div>
}
<div class="jhmi-inbox-modals">
  @if (unlockMessage) {
    <div class="jhm-modal-background">
      <div id="inbox-unlock-message-modal" class="jhm-modal">
        @if (unlockMessage.creditsUsed <= creditsAvailable) {
          <div class="unlock">
            <button class="jhm-icon-button transparent exit" (click)="closeUnlockModalClicked()"><i class="fa-regular fa-times"></i></button>
            <div class="modal-badge safe"><i class="fa-regular fa-lock"></i></div>
            <div class="summary">
              Would you like to unlock <span class="bolded">{{unlockMessage.senderFullName}}'s</span> message for {{unlockMessage.creditsUsed | centsToDollars}}?
            </div>
            <hr class="modal-divider" />
            <div class="line-item">
              <div>Your Balance</div>
              <div class="line-item-value">{{creditsAvailable | centsToDollars}}</div>
            </div>
            <hr class="modal-dashed-divider" />
            <div class="line-item">
              <div>Message</div>
              <div>1 Credit</div>
            </div>
            <hr class="modal-dashed-divider" />
            <div class="line-item">
              <div>Total</div>
            <div class="line-item-value">{{unlockMessage.creditsUsed | centsToDollars}}</div>
            </div>
          </div>
        }
        @if (unlockMessage.creditsUsed > creditsAvailable) {
          <div class="unlock">
            <button class="jhm-icon-button transparent exit" (click)="closeUnlockModalClicked()"><i class="fa-regular fa-times"></i></button>
            <div class="modal-badge unsafe"><i class="fa-regular fa-envelope-open-dollar"></i></div>
            <div class="summary">
              <span class="bolded">Purchase more credit</span> to unlock this message.
            </div>
            <hr class="modal-divider" />
            <div class="line-item">
                <div>Your Balance</div>
                <div class="warning" class="line-item-value">{{creditsAvailable | centsToDollars}}</div>
            </div>
            <hr class="modal-dashed-divider" />
            <div class="line-item">
              <div>Message</div>
              <div>$0.25</div>
            </div>
            <hr class="modal-dashed-divider" />
            <div class="line-item">
                <div>Total</div>
                <div class="line-item-value">{{unlockMessage.creditsUsed | centsToDollars}}</div>
            </div>
          </div>
        }
        <footer class="filled modal-buttons">
          <button class="jhm-button" (click)="closeUnlockModalClicked()">Cancel</button>
          @if (unlockMessage.creditsUsed <= creditsAvailable) {
            <button class="jhm-button primary" (click)="unlockMessageClicked()">Unlock for {{unlockMessage.creditsUsed | centsToDollars}}</button>
          }
          @if (unlockMessage.creditsUsed > creditsAvailable) {
            <button class="jhm-button danger" (click)="purchaseCreditsClicked()">Purchase Credit</button>
          }
        </footer>
      </div>
    </div>
  }
</div>
@if (showStripeModal) {
  <jhm-stripe-purchase (exit)="showStripeModal = false;"></jhm-stripe-purchase>
}
@if (loading) {
  <jhm-loading></jhm-loading>
}